import Content from "../../content/Content";
import { SITE_TYPES } from "../../core/constants";
import { Page as PageType } from "../../resources/modelTypes";
import { getPageHasGeneralContent } from "../../shared/utils/utils";
import PageContentSeparator from "./PageContentSeparator";
import PageTitle from "./PageTitle";
import { css } from "@emotion/react";
import { LargeDivider } from "@minted/fancyclothes";
import { DesignComponent } from "@minted/fancyclothes";
import { styleUtils } from "@minted/minted-components";
import React from "react";

const centeredTextStyles = css`
  text-align: center;
`;

const marginBottomStyles = (siteType?: string) => css`
  margin-bottom: ${styleUtils.rem(
    siteType === SITE_TYPES.ONLINE_INVITATION ? 40 : 80,
  )};
`;

const paddingTopStyles = (siteType?: string) => css`
  padding-top: ${styleUtils.rem(
    siteType === SITE_TYPES.ONLINE_INVITATION ? 40 : 80,
  )};
`;

const wrapperStyles = css`
  margin: 0 auto;
  max-width: ${styleUtils.rem(975)};
  scroll-margin-top: ${styleUtils.rem(100)};
`;

export interface PageProps {
  children: React.ReactNode;
  id: string;
  pageData: PageType | null;
  removeSpacing?: boolean;
  siteType?: string;
  title?: string;
}

class Page extends DesignComponent<PageProps> {
  props!: PageProps;

  render() {
    const {
      children,
      id,
      pageData,
      removeSpacing = false,
      siteType,
      title,
    } = this.props;

    const themeHasDividers = Boolean(
      (this as any).getRule("graphic", "LargeDivider"),
    );
    const hasGeneralContent = getPageHasGeneralContent(pageData || {});

    return (
      <>
        <div
          css={css`
            ${wrapperStyles};
            ${!removeSpacing && paddingTopStyles(siteType)}
          `}
          id={`page-${id}`}
        >
          <div css={centeredTextStyles}>
            {Boolean(title) && <PageTitle title={title!} />}
          </div>
          {hasGeneralContent && pageData && (
            <>
              <Content
                configuration={pageData.configuration}
                description={pageData.content}
                image={pageData.image}
                photoPk={pageData.photo}
                title={pageData.title}
              />
              <PageContentSeparator isCentered />
            </>
          )}
          <div
            css={
              (!removeSpacing || themeHasDividers) &&
              marginBottomStyles(siteType)
            }
          >
            {children}
          </div>
        </div>
        <LargeDivider />
      </>
    );
  }
}

// Export as a properly typed React component for TypeScript
const TypedPage = Page as unknown as React.ComponentType<PageProps>;

export default TypedPage;
